import { Box, Input, InlineAlert, InputProps } from '@cmpsr/components';
import { Icon } from '@chakra-ui/react';
import type { UseFormRegisterReturn } from 'react-hook-form';

interface InputFieldProps extends InputProps {
  name: string;
  placeholder: string;
  type?: string;
  autoComplete?: string;
  icon?: React.ElementType; // Icon component, e.g., ProfileIcon
  registerProps?: UseFormRegisterReturn;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  defaultValue?: string;
}

const COMMON_ICON_PROPS = {
  width: '1.5rem',
  height: '1.5rem',
  color: '#ADB4C0',
  ml: '1.25rem',
};

const InputField = ({
  name,
  placeholder,
  type = 'text',
  autoComplete,
  icon,
  registerProps,
  onBlur,
  onInput,
  errorMessage,
  defaultValue,
  ...rest
}: InputFieldProps) => {
  const leadingIcon = icon ? <Icon as={icon} {...COMMON_ICON_PROPS} /> : undefined;

  return (
    <Box gap="spacer-0">
      <Input
        {...(!registerProps && { name })}
        placeholder={placeholder}
        color="black"
        backgroundColor={'white'}
        _hover={{ backgroundColor: 'transparent' }}
        _placeholder={{ color: '#ADB4C0' }}
        py="1rem"
        border="none"
        borderRadius="2rem"
        defaultValue={defaultValue}
        type={type}
        autoComplete={autoComplete}
        leadingIcon={leadingIcon}
        pl="3.5rem"
        {...(registerProps || { onBlur })}
        onInput={onInput}
        fontSize="16px"
        {...rest}
      />
      {errorMessage ? (
        <InlineAlert status="error" mt="spacer-6" mb="spacer-6" alignItems="flex-start" px="1.25rem">
          <InlineAlert.Icon />
          <InlineAlert.Message>
            <Box color="salmon-light">{errorMessage}</Box>
          </InlineAlert.Message>
        </InlineAlert>
      ) : null}
    </Box>
  );
};

export default InputField;
